import { Accordion } from "@chakra-ui/react";
import FaqElement from "components/blocks/FaqElement";
import Text from "components/base/Text";
import Trans from "components/base/Trans";
import { MotionBox as Box, MotionContainer as Container } from "utils/motion";

const FaqSection = ({
  items = [],
  title,
  subtitle,
  noSubtitle,
  defaultIndex,
  onClick,
  onLinkClick,
  local,
  bg,
  ...props
}) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <Box width="100%" bg={bg || "black.700"}>
      <Container small {...props}>
        {!noSubtitle && (
          <Text
            type="title_md"
            textTransform="uppercase"
            color="primary"
            mb="xxs"
          >
            {subtitle || <Trans id="LBL_MENU_FAQ" />}
          </Text>
        )}
        {title && (
          <Text
            type="headline_md"
            mb={["md", null, "lg"]}
            textAlign="left"
            color="white"
            w="full"
          >
            {title}
          </Text>
        )}
        <Box w="100%">
          <Accordion allowToggle defaultIndex={defaultIndex}>
            {items.map((item) => (
              <div id={item.uid} key={item.uid}>
                <FaqElement
                  local={local}
                  question={item.question}
                  answer={item.answer}
                  uid={item.uid}
                  onClick={onClick}
                  onLinkClick={onLinkClick}
                />
              </div>
            ))}
          </Accordion>
        </Box>
      </Container>
    </Box>
  );
};

export default FaqSection;
